export default function BrandingSkeleton() {
	return (
		<div className="space-y-6 animate-pulse">
			{/* Main container */}
			<div className="flex border border-gray-200 bg-white rounded-lg">
				{/* Left panel - Settings (w-1/3) */}
				<div className="w-1/3 border-r border-gray-200 p-6 pb-0 flex flex-col divide-y divide-gray-200 space-y-6">
					{/* Colors Section */}
					<div>
						<div className="flex items-center justify-between mb-4">
							<div className="h-5 w-16 bg-gray-200 rounded"></div>
						</div>
						<div>
							{/* Primary Color */}
							<div className="mb-6">
								<div className="h-4 w-14 bg-gray-200 rounded mb-2"></div>
								<div className="mt-2 flex items-center gap-3">
									<div className="w-[38px] h-[38px] rounded-xl bg-gray-200"></div>
									<div className="h-[38px] w-28 bg-gray-200 rounded-lg"></div>
								</div>
							</div>
							{/* Accent Color */}
							<div className="mb-6">
								<div className="h-4 w-14 bg-gray-200 rounded mb-2"></div>
								<div className="mt-2 flex items-center gap-3">
									<div className="w-[38px] h-[38px] rounded-xl bg-gray-200"></div>
									<div className="h-[38px] w-28 bg-gray-200 rounded-lg"></div>
								</div>
							</div>
						</div>
					</div>

					{/* Typography Section */}
					<div>
						<div className="flex items-center justify-between mb-4">
							<div className="h-5 w-24 bg-gray-200 rounded"></div>
						</div>
						<div>
							{/* Heading Font */}
							<div className="mb-4">
								<div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
								<div className="grid grid-cols-2 gap-3">
									<div className="h-[38px] bg-gray-200 rounded-lg"></div>
									<div className="h-[38px] bg-gray-200 rounded-lg"></div>
								</div>
							</div>
							{/* Body Font */}
							<div className="mb-6">
								<div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
								<div className="grid grid-cols-2 gap-3">
									<div className="h-[38px] bg-gray-200 rounded-lg"></div>
									<div className="h-[38px] bg-gray-200 rounded-lg"></div>
								</div>
							</div>
						</div>
					</div>

					{/* Logo Section */}
					<div>
						<div className="flex items-center justify-between mb-4">
							<div className="h-5 w-16 bg-gray-200 rounded"></div>
						</div>
						<div>
							{/* Light/Dark Toggle */}
							<div className="relative inline-flex bg-gray-100 rounded-lg p-1 mb-6">
								<div className="w-[calc(50%-0.25rem)] h-8 bg-gray-200 rounded-md"></div>
								<div className="absolute inset-0 flex">
									<div className="w-1/2 h-full"></div>
									<div className="w-1/2 h-full"></div>
								</div>
							</div>
							{/* Logo upload fields - showing light mode by default */}
							<div className="space-y-6 py-6">
								{/* Icon only */}
								<div>
									<div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
									<div className="w-1/2">
										<div className="aspect-square w-full bg-gray-100 rounded-xl border-2 border-dashed border-gray-200"></div>
									</div>
								</div>
								{/* Label only */}
								<div>
									<div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
									<div className="aspect-3/1 w-full bg-gray-100 rounded-xl border-2 border-dashed border-gray-200"></div>
								</div>
								{/* Icon with label */}
								<div>
									<div className="h-4 w-32 bg-gray-200 rounded mb-2"></div>
									<div className="aspect-3/1 w-full bg-gray-100 rounded-xl border-2 border-dashed border-gray-200"></div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Right panel - Preview (w-2/3) */}
				<div className="w-2/3 flex flex-col">
					{/* Preview Header */}
					<div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
						<div className="flex items-center gap-6">
							<div className="h-5 w-28 bg-gray-200 rounded"></div>
							<div className="h-3 w-48 bg-gray-200 rounded"></div>
						</div>
						<div className="flex items-center gap-3">
							<div className="flex items-center gap-2">
								<div className="h-3 w-16 bg-gray-200 rounded"></div>
								<div className="w-10 h-5 bg-gray-200 rounded-full"></div>
							</div>
						</div>
					</div>

					{/* Preview Content */}
					<div className="min-h-screen flex flex-col bg-gray-50 flex-1">
						{/* Progress bar */}
						<div className="z-10 h-1 w-full shrink-0 bg-gray-200"></div>

						{/* Main container */}
						<div className="flex-1 flex flex-col w-full max-w-xl mx-auto px-6 md:px-8">
							{/* Header with logo */}
							<header className="pt-20 pb-10 shrink-0">
								<div className="h-10 w-32 bg-gray-200 rounded"></div>
							</header>

							{/* Content area */}
							<main className="flex-1 flex flex-col">
								{/* Eyebrow */}
								<div className="mb-3">
									<div className="h-3 w-32 bg-gray-200 rounded"></div>
								</div>

								{/* Title */}
								<div className="mb-3">
									<div className="h-10 w-64 bg-gray-200 rounded mb-2"></div>
									<div className="h-10 w-56 bg-gray-200 rounded"></div>
								</div>

								{/* Subtitle */}
								<div className="mb-8">
									<div className="h-4 w-full bg-gray-200 rounded mb-2"></div>
									<div className="h-4 w-3/4 bg-gray-200 rounded"></div>
								</div>

								{/* Main content */}
								<div className="mt-8 md:mt-10">
									<div className="p-4 bg-white rounded-lg border border-gray-200">
										<div className="h-4 w-32 bg-gray-200 rounded"></div>
									</div>
								</div>
							</main>
						</div>

						{/* Footer with buttons */}
						<footer className="sticky bottom-0 z-10 shrink-0">
							{/* Fade gradient */}
							<div className="h-16 bg-linear-to-t from-gray-50 to-transparent pointer-events-none"></div>
							<div className="bg-white py-5 md:py-6 border-t border-gray-100">
								<div className="w-full max-w-xl mx-auto px-6 md:px-8">
									<div className="flex items-center gap-3">
										{/* Back button */}
										<div className="w-[120px] shrink-0">
											<div className="h-10 w-full bg-gray-200 rounded-lg"></div>
										</div>

										{/* Center branding */}
										<div className="flex-1 flex justify-center">
											<div className="h-8 w-40 bg-gray-200 rounded-full"></div>
										</div>

										{/* Continue button */}
										<div className="w-[120px] shrink-0">
											<div className="h-10 w-full bg-gray-200 rounded-lg"></div>
										</div>
									</div>
								</div>
							</div>
						</footer>
					</div>
				</div>
			</div>
		</div>
	);
}
